import { viewportObserver } from '@nova/utils'

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
    this.recommendUrl = this.getAttribute('data-url')
    this.recommendationContainer = this.querySelector(
      '[data-recommendations-container]',
    )
    this.loadRecommendations()
  }

  loadRecommendations() {
    fetch(this.recommendUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        const recommendedContent = html.querySelector(
          '[data-recommendations-container]',
        )
        if (recommendedContent) {
          this.recommendationContainer.innerHTML = recommendedContent.innerHTML
          window.NovaProductCardV2?.initWithin(this.recommendationContainer)
        }

        const resizeObserver = this.recommendationContainer.querySelector(
          '.js-resize-observer',
        )

        const carousel =
          this.recommendationContainer.querySelector('.js-carousel')

        resizeObserver.addEventListener('sl-resize', () => {
          const viewpoint = viewportObserver.getCurrentViewport()
          switch (viewpoint) {
            case 'mobile':
              carousel.setAttribute('slides-per-page', 1.3)
              break
            case 'tablet':
              carousel.setAttribute('slides-per-page', 2.3)
              break
            case 'desktop':
              carousel.setAttribute('slides-per-page', 3.3)
              break
            case 'widescreen':
              carousel.setAttribute('slides-per-page', 3.3)
              break
            default:
              carousel.setAttribute('slides-per-page', 3.3)
              break
          }
        })

      })
  }
}

customElements.define('nova-product-recommendations', ProductRecommendations)
